import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Button, Input, TextArea } from 'semantic-ui-react';
import { Text, Row, Col, Separator } from '@cuemath/comps';

const LongInput = styled(Input)`
  width: 200px;
`;
const LongTextArea = styled(TextArea)`
  width: 500px;
  height: 40px;
`;

const getInitialInput = initialData => {
  return initialData.map(data => ({
    textValue: data,
  }));
};

const INPUT_TYPE = {
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
};

const INPUT_TYPE_COMPONENT_MAP = {
  TEXT: LongInput,
  TEXTAREA: LongTextArea,
};

export default class MultipleTextInput extends PureComponent {
  static defaultProps = {
    inputType: INPUT_TYPE.TEXT,
  };

  static propTypes = {
    initialInput: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    inputType: PropTypes.string,
  };

  constructor(props) {
    super();
    const { initialInput } = props;

    this.state = {
      inputs: getInitialInput(initialInput),
    };
  }

  handleChange = (index, key, value) => {
    const { inputs } = this.state;
    this.setState(
      {
        inputs: [
          ...inputs.slice(0, index),
          { ...inputs[index], [key]: value },
          ...inputs.slice(index + 1, inputs.length),
        ],
      },
      () => {
        this.handleSubmit();
      },
    );
  };

  onDeleteClick = index => {
    const { inputs } = this.state;
    this.setState(
      {
        inputs: [...inputs.slice(0, index), ...inputs.slice(index + 1, inputs.length)],
      },
      () => {
        this.handleSubmit();
      },
    );
  };

  renderInputs = () => {
    const { inputType } = this.props;
    const { inputs } = this.state;
    const inputComps = [];
    const InputComponent = INPUT_TYPE_COMPONENT_MAP[inputType];
    inputs.forEach((input, index) => {
      const { textValue } = input;

      inputComps.push(
        <Row gap={4} key={index} alignItems="center">
          <Col>
            <InputComponent
              name="textValue"
              value={textValue}
              onChange={(e, { name, value }) => {
                this.handleChange(index, name, value);
              }}
            />
          </Col>
          <Col>
            <Button
              size="mini"
              circular
              color="red"
              icon="close"
              onClick={() => {
                this.onDeleteClick(index);
              }}
            />
          </Col>
        </Row>,
      );
    });
    return inputComps;
  };

  onNewFieldAddClick = () => {
    const { inputs } = this.state;
    this.setState({
      inputs: [...inputs, { textValue: '' }],
    });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { inputs } = this.state;
    const responseData = inputs.map(input => input.textValue);
    onSubmit(responseData);
  };

  render() {
    const { label } = this.props;
    return (
      <>
        <Row alignItems="center">
          <Col>
            <Text>{label}</Text>
          </Col>
          <Col>
            <Button
              color="blue"
              icon="plus"
              content={'Add new'}
              onClick={this.onNewFieldAddClick}
            />
          </Col>
        </Row>
        <Separator transparent height="6" />
        {this.renderInputs()}
      </>
    );
  }
}
